import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconEye24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.044c-2.455 0-4.99-1.296-7.03-4.044C7.01 9.252 9.544 7.956 12 7.956S16.99 9.252 19.03 12c-2.04 2.748-4.575 4.044-7.03 4.044zm8.57-4.469C18.267 8.223 15.178 6.456 12 6.456s-6.267 1.767-8.57 5.12a.75.75 0 000 .849c2.303 3.352 5.392 5.119 8.57 5.119s6.267-1.767 8.57-5.12a.75.75 0 000-.849zM12 15a3 3 0 100-6 3 3 0 000 6z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconEye24);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;